(function () {
    'use strict';

    angular.module("imApp").factory("labourSalaryTypesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1421,
                    parameters: parms || {}
                });
            },
            listSalaryTypes: function (parms) {
                return $ihttp.post({
                    method: 1422,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
